import { render, staticRenderFns } from "./AppCard.vue?vue&type=template&id=639c9506&scoped=true"
import script from "./AppCard.vue?vue&type=script&lang=js"
export * from "./AppCard.vue?vue&type=script&lang=js"
import style0 from "./AppCard.vue?vue&type=style&index=0&id=639c9506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c9506",
  null
  
)

export default component.exports